import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const goodsReceiveStore = {
    namespaced: true,
    actions:{
        getGRPrefixList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/GetGRPrefixList', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getGRHeader({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/GetGRHeader', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getGRDetails({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/GetGRDetails', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getGRMiscChg({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/GetGRMiscChg', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getGoodsReceiveList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/GetGRList', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },   
        unpostGR({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/gr/unpostGR', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },          
        saveGoodsReceive({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/AddGR', JSON.stringify({txHdr: param.header, txDtlList: param.details, txMiscChgList: param.misc})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        updateGoodsReceive({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/UpdateGR', JSON.stringify({txHdr: param.header, txDtlList: param.details, txMiscChgList: param.misc, oldPONum: param.oldPONum, oldSANum: ""})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        deleteGoodsReceive({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/CancelGR', JSON.stringify({modelTxHdr: param.header})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getStockPivotList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/StockPivotList', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        postGR({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/gr/postgr', JSON.stringify({modelHdr: param.header, txDtlList: param.details, txMiscChgList: param.misc, oldPONum:param.oldPONum,oldSANum:param.oldSANum})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        grRpt({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/gr/grrpt').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        printGR({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/GR/Print', { txNum: param.txNum, rptID: param.rptID }, { responseType: 'blob' }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        
    }
};
export default goodsReceiveStore;